import * as go from 'gojs';
import theme from 'theme/theme';
import { PanelNames } from '../utils/panelNames';

const $ = go.GraphObject.make;

export const getBorderStroke = () =>
  new go.Binding('stroke', '', (node) => {
    return node.data.selected || node.data.active
      ? theme.palette.info.main
      : theme.palette.grey['300'];
  }).ofObject();

export const getTitleStroke = () =>
  new go.Binding('stroke', '', (data) => {
    return data.selected ? theme.palette.info.main : theme.palette.grey['900'];
  });

export const getTextStroke = () => theme.palette.grey['900'];

export const getFillColor = () =>
  new go.Binding('fill', '', (_, _node) => {
    return 'white';
  });

export const panelMargin = () => ({ margin: new go.Margin(8, 10, 8, 10) });

export const roundedPanel = () =>
  $(
    go.Shape,
    'RoundedRectangle',
    {
      name: PanelNames.INFO_PANEL_SHAPE,
      strokeWidth: 1,
      stretch: go.GraphObject.Fill,
      parameter1: 8,
    },
    getFillColor(),
    getBorderStroke(),
  );
